export default function (value) {
    return value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
}